export default "__VITE_ASSET__8Qy3eYGhg1HJICLIVd0IJw__";